<template>
	<div>
		<!-- schedule modal -->
		<base-modal :show="showSchedule" title="Schedule" @close="close">
			<div class="form-check d-flex">
				<input
					class="form-check-input"
					type="checkbox"
					value=""
					id="flexCheckDefault"
					v-model="leagueSchedule"
				/>
				<label class="form-check-label text-white" for="flexCheckDefault"> League Schedule </label>
			</div>
			<table v-if="leagueSchedule" class="table table-dark">
				<thead>
					<tr>
						<th scope="row">Week</th>
						<th scope="col">Home</th>
						<th scope="col"></th>

						<th scope="col">Away</th>
					</tr>
				</thead>
				<tbody></tbody>
				<tbody v-for="sched in schedule" :key="sched">
					<tr v-for="games in sched.schedule" :key="games">
						<td>
							{{ games.week }}
						</td>
						<td>{{ games.home }}</td>
						<td>vs</td>
						<td>{{ games.away }}</td>
					</tr>
				</tbody>
			</table>
			<table v-else class="table table-dark">
				<thead>
					<tr>
						<th scope="col">Week</th>
						<th scope="col">Home</th>
						<th scope="col"></th>

						<th scope="col">Away</th>
					</tr>
				</thead>
				<tbody></tbody>
				<tbody v-for="sched in schedule" :key="sched">
					<tr v-for="games in sched.schedule" :key="games">
						<td v-if="games.home === getUserTeam || games.away === getUserTeam">
							{{ games.week }}
						</td>
						<td v-if="games.home === getUserTeam || games.away === getUserTeam">{{ games.home }}</td>
						<td v-if="games.home === getUserTeam || games.away === getUserTeam">vs</td>
						<td v-if="games.home === getUserTeam || games.away === getUserTeam">{{ games.away }}</td>
					</tr>
				</tbody>
			</table>
		</base-modal>
		<!-- stats modal -->
		<base-modal :show="showStatsForm" @close="close">
			<form @submit.prevent="addStats">
				<div v-for="user of selectedPlayer" :key="user">
					<h2 class="text-info mb-2">{{ user.firstName }} {{ user.lastName }}</h2>
					<p v-if="getStats.userId === selectedPlayer.user.id" class="text-info mb-5">
						<span v-if="getStats.BA !== NaN"
							>BA: {{ getStats.BA }} / OBP%: {{ getStats.OBP }}/ SLG%: {{ getStats.SLG }}
						</span>
					</p>
				</div>
				<h5 class="text-light text-start border-bottom mb-4">Batting Stats</h5>
				<div class="row g-2">
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="atBats" v-model="atBats" />
							<label for="atBats">At Bats</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="walks" v-model="walks" />
							<label for="walks">Walks</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="hbp" v-model="hbp" />
							<label for="hbp">HBP</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="sf" v-model="sf" />
							<label for="sf">SF</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="so" v-model="so" />
							<label for="so">Strikeouts</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="single" v-model="singles" />
							<label for="single">Singles</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="double" v-model="doubles" />
							<label for="double">Doubles</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="triples" v-model="triples" />
							<label for="Triples">Triples</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input type="number" class="form-control" id="homeruns" v-model="homeruns" />
							<label for="homeruns">Homeruns</label>
						</div>
					</div>
				</div>
				<div v-for="pos in selectedPlayer.user.positions" :key="pos" class="mb-5">
					<div v-if="pos === 'P'" class="row g-2 mt-1">
						<h5 class="text-light text-start border-bottom mb-4 mt-5">Pitching Stats</h5>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="ip" v-model="ip" />
								<label for="ip">IP</label>
							</div>
						</div>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="hits" v-model="hits" />
								<label for="hits">Hits</label>
							</div>
						</div>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="runs" v-model="runs" />
								<label for="runs">Runs</label>
							</div>
						</div>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="er" v-model="er" />
								<label for="er">Earned Runs</label>
							</div>
						</div>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="bb" v-model="bb" />
								<label for="bb">Walks</label>
							</div>
						</div>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="k" v-model="k" />
								<label for="k">Strikeouts</label>
							</div>
						</div>
						<div class="col-md">
							<div class="form-floating">
								<input type="number" class="form-control" id="hr" v-model="hr" />
								<label for="hr">Homeruns</label>
							</div>
						</div>
					</div>
				</div>
				<div>
					<button class="btn btn-outline-info btn-lg mt-4 float-end">Save</button>
					<button @click="close" type="button" class="btn btn-outline-danger btn-lg mt-4 float-start">
						cancel
					</button>
				</div>
			</form>
		</base-modal>
		<!-- line up modal -->
		<base-modal :show="showSetLineUp" @close="close" title="Set Line Up">
			<set-lineup
				:getAllSchedules="getAllSchedules"
				:getUsers="getUsers"
				:getUserTeam="getUserTeam"
				:getLineUp="getLineUp"
				:getTeamId="getTeamId"
				@load-lineups="loadLineUps"
				@close="close"
				:compKey="compKey"
			></set-lineup>
		</base-modal>
		<!-- SECTION -->
		<h1 class="text-info mt-4">Coach Dashboard</h1>
		<!-- first row -->
		<div class="row row-cols-1 row-cols-md-3 g-4">
			<div class="col">
				<!-- LEAGUE PLAYERS AND TEAMS CARD -->
				<div class="card h-100 text-info" style="background-color: #263238">
					<div class="card-body">
						<h3 class="card-title">
							{{ getUsers.length }} {{ getUserTeam }} Player{{
								getUsers.length === 0 || getUsers.length > 1 ? 's' : ''
							}}
						</h3>
						<div class="list-group">
							<a
								v-for="user in getUsers"
								:key="user"
								href="#"
								class="list-group-item list-group-item-action list-group-item-info"
							>
								<div class="row">
									<div class="col text-start">{{ user.userType }}</div>
									<div class="col text-start">
										{{ user.firstName }} {{ user.lastName.charAt(0) }}.
									</div>
									<div class="col text-end">
										<span v-for="(pos, index) in user.positions" :key="pos">
											{{ pos }}<span v-if="index != user.positions.length - 1">, </span>
										</span>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="card-footer">
						<!-- <small class="text-muted">Last updated 3 mins ago</small> -->
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card h-100 text-info" style="background-color: #37474F">
					<div class="card-body">
						<h3 class="card-title text-black-50">{{ truncLeagueName }} {{ userDivision }} Standings</h3>
						<h4 class="mt-5">Coming Soon!</h4>
					</div>
					<div class="card-footer"></div>
				</div>
			</div>
			<div class="col">
				<!-- SCHEDULE CARD -->
				<div class="card h-100 text-info" style="background-color: #263238">
					<div class="card-body">
						<h3 class="card-title">Schedules</h3>
						<div class="list-group">
							<a
								v-for="schedule in getAllSchedules"
								:key="schedule"
								role="button"
								@click="scheduleDetails(schedule.id, getUserTeam)"
								class="list-group-item list-group-item-action list-group-item-info"
								>{{ schedule.season }}</a
							>
						</div>
					</div>
					<div class="card-footer">
						<small class="text-muted">
							<div></div>
						</small>
					</div>
				</div>
			</div>
		</div>
		
		<!-- second row -->
		<div class="row row-cols-1 row-cols-md-2 g-4 mt-1">
			<div class="col">
				<!-- ADD PLAYER STATS-->
				<div class="card h-100 text-info" style="background-color: #263238">
					<div class="card-body">
						<h3 class="card-title">Add Stats</h3>
						<div class="form-floating">
							<select class="form-select" id="floatingSelectGrid" v-model="selectedPlayer">
								<option v-for="user in getUsers" :key="user" :value="{ user }">
									{{ user.firstName }} {{ user.lastName }}
								</option>
							</select>
							<label for="floatingSelectGrid">Add stats for </label>
						</div>
						<button
							v-if="selectedPlayer"
							class="btn btn-outline-info btn-block mt-4"
							@click="showStatsForm = true"
						>
							Add Stats
						</button>
					</div>
					<div class="card-footer">
						<!-- <small class="text-muted">Last updated 3 mins ago</small> -->
					</div>
				</div>
			</div>
			<div class="col">
				<!-- SET LINE UP -->
				<div class="card h-100 text-info" style="background-color: #263238">
					<div class="card-body">
						<h3 class="card-title">Line Up</h3>
						<div class="form-floating mt-1">
							<select class="form-select" v-model.trim="selectedViewSchedule" id="selectedSchedule">
								<option
									v-for="sched in getAllSchedules"
									:key="sched.id"
									:value="{ schedule: sched.schedule, season: sched.season }"
								>
									{{ sched.season }}
								</option>
							</select>
							<label for="floatingSelectGridL">Choose a schedule to view a line up</label>
						</div>
						<div v-if="selectedViewSchedule" class="form-floating mt-3 mb-5">
							<select class="form-select" v-model.trim="selectedViewGame" id="selectedSchedule">
								<option>Week # - Home vs Away</option>
								<option
									v-for="game of getSelectedScheduleLineUp(selectedViewSchedule)"
									:key="game.week"
									:value="{ home: game.game.home, away: game.game.away, week: game.game.week }"
								>
									Week {{ game.game.week }} - {{ game.game.home }} vs {{ game.game.away }}
								</option>
							</select>
							<label for="floatingSelectGridL">Choose a game</label>
						</div>
						<div v-if="selectedViewGame">
							<div v-for="lineup of selectedGameLineUp(selectedViewGame)" :key="lineup">
								<div class="row mt-5 overflow-auto">
									<div class="col pe-0">
										<h6 class="border-bottom pb-2">Batting</h6>
										<ul class="list-group list-group-flush">
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												1
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												2
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												3
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												4
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												5
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												6
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												7
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												8
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												9
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												10
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												11
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												12
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												13
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												14
											</li>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												15
											</li>
										</ul>
									</div>
									<div class="col px-0">
										<h6 class="border-bottom pb-2">Player</h6>
										<ul
											v-for="batting in lineup.battingOrder"
											:key="batting"
											class="list-group list-group-flush"
										>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												{{ batting.firstName }}
											</li>
										</ul>
									</div>
									<div class="col ps-0">
										<h6 class="border-bottom pb-2">Position</h6>
										<ul
											v-for="pos in lineup.positionOrder"
											:key="pos"
											class="list-group list-group-flush"
										>
											<li
												class="list-group-item text-info border-bottom"
												style="background-color: #263238"
											>
												{{ pos.pos }}
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<button class="btn btn-outline-info mt-4 me-md-0 me-xl-4" @click="showSetLineUp = true">
							Set a new line up
						</button>
						<button disabled class="btn btn-info mt-4" @click="showEditLineUp = true">
							Edit line up <small>(coming soon)</small>
						</button>
					</div>
					<div class="card-footer">
						<small class="text-muted">
							<div></div>
						</small>
					</div>
				</div>
			</div>
		</div>
		<!-- third row -->
		<div class="row mt-4">
			<div class="col" style="min-height: 800px;">
				<!-- TEAM STATS -->
				<team-stats-table :getUsers="getUsers"></team-stats-table>
			</div>
		</div>
	</div>
</template>

<script>
import LeagueScheduleForm from '@/components/league/LeagueScheduleForm.vue';
import TeamStatsTable from '@/components/stats/TeamStatsTable.vue';
import SetLineup from '@/components/team/SetLineup.vue';
export default {
	components: {
		LeagueScheduleForm,
		TeamStatsTable,
		SetLineup,
	},
	data() {
		return {
			showSchedule: false,
			schedule: null,
			leagueSchedule: false,
			selectedPlayer: null,
			showStatsForm: false,
			atBats: 0,
			walks: 0,
			hbp: 0,
			sf: 0,
			so: 0,
			singles: 0,
			doubles: 0,
			triples: 0,
			homeruns: 0,
			ip: 0,
			hits: 0,
			runs: 0,
			er: 0,
			bb: 0,
			k: 0,
			hr: 0,
			BA: 0,
			OBP: 0,
			SLG: 0,
			showSetLineUp: false,
			selectedViewSchedule: null,
			selectedViewGame: null,
			gamesWithLineUps: [],
			showEditLineUp: false,
			componentKey: 0,
			compKey: 0
		};
	},
	created() {
		this.loadSchedules();
		this.loadUsers();
		this.loadTeams();
		this.loadLineUps();
	},

	computed: {
		userLeague() {
			return this.$store.getters.userLeague;
		},
		userLeagueId() {
			return this.$store.getters.userLeagueId;
		},
		getAllSchedules() {
			return this.$store.getters['leagues/allSchedules'];
		},
		getAllTeams() {
			return this.$store.getters['teams/allTeams'];
		},
		getTeamId() {
			return this.$store.getters.userTeamId;
		},
		getUserTeam() {
			return this.$store.getters.userTeam;
		},
		getLineUp() {
			return this.$store.getters['teams/getLineUps'];
		},
		getDivisions() {
			return this.$store.getters['leagues/allDivisions'];
		},
		userDivisionId() {
			return this.$store.getters.userDivisionId;
		},
		userDivision() {
			return this.$store.getters.userDivision;
		},
		getStats() {
			return this.$store.getters['stats/getStats'];
		},
		getUsers() {
			const users = this.$store.getters.allUsers;
			const filteredUsers = users.filter((i) => i.userType !== 'League Manager');
			const loggedUser = this.$store.getters.userTeam;
			this.players = filteredUsers;
			return filteredUsers
				.filter((user) => user.team === loggedUser)
				.sort((a, b) => {
					if (a.firstName < b.firstName) return -1;
					if (a.firstName > b.firstName) return 1;
				});
		},
		truncLeagueName() {
			const league = this.$store.getters.userLeague;
			const index = league.indexOf('-');
			return league.slice(0, index);
		},
	},
	watch: {
		selectedDivision() {
			this.loadTeams();
			this.loadSchedules();
		},
		selectedPlayer() {
			this.loadUserStats();
			this.getStats;
		},
	},
	methods: {
		async addStats() {
			if (this.getStats.atBats) {
				var pitcher = false;
				var newPitcher = false;
				for (const pos of this.selectedPlayer.user.positions) {
					if (pos === 'P' && this.getStats.ip !== undefined) {
						pitcher = true;
					} else if (pos === 'P' && this.getStats.ip === undefined) {
						newPitcher = true;
					}
				}
				console.log(newPitcher);
				// if user has batting stats and recently added pitcher as a position
				if (newPitcher === true) {
					const payload = {
						atBats: this.atBats + this.getStats.atBats,
						walks: this.walks + this.getStats.walks,
						hbp: this.hbp + this.getStats.hbp,
						so: this.so + this.getStats.so,
						sf: this.sf + this.getStats.sf,
						singles: this.singles + this.getStats.singles,
						doubles: this.doubles + this.getStats.doubles,
						triples: this.triples + this.getStats.triples,
						homeruns: this.homeruns + this.getStats.homeruns,
						ip: this.ip,
						hits: this.hits,
						runs: this.runs,
						er: this.er,
						bb: this.bb,
						k: this.k,
						hr: this.hr,
						user: this.selectedPlayer.user,
						// SET BA, OBP, SLG on send so it can be pulled easier or when setting users set it
					};
					console.log(payload);
					try {
						await this.$store.dispatch('stats/addNewStats', payload);
					} catch (error) {
						this.error = error.message || 'Something failed!';
					}
					this.atBats = 0;
					this.walks = 0;
					this.hbp = 0;
					this.sf = 0;
					this.so = 0;
					this.singles = 0;
					this.doubles = 0;
					this.triples = 0;
					this.homeruns = 0;
					this.ip = 0;
					this.hits = 0;
					this.runs = 0;
					this.er = 0;
					this.bb = 0;
					this.k = 0;
					this.hr = 0;
					this.loadUserStats();
					this.close();
					// if user is a pitcher and has batting stats and picthing stats
				} else if (pitcher === true) {
					const payload = {
						atBats: this.atBats + this.getStats.atBats,
						walks: this.walks + this.getStats.walks,
						hbp: this.hbp + this.getStats.hbp,
						sf: this.sf + this.getStats.sf,
						so: this.so + this.getStats.so,
						singles: this.singles + this.getStats.singles,
						doubles: this.doubles + this.getStats.doubles,
						triples: this.triples + this.getStats.triples,
						homeruns: this.homeruns + this.getStats.homeruns,
						ip: this.ip + this.getStats.ip,
						hits: this.hits + this.getStats.hits,
						runs: this.runs + this.getStats.runs,
						er: this.er + this.getStats.er,
						bb: this.bb + this.getStats.bb,
						k: this.k + this.getStats.k,
						hr: this.hr + this.getStats.hr,
						user: this.selectedPlayer.user,
					};
					try {
						await this.$store.dispatch('stats/addNewStats', payload);
					} catch (error) {
						this.error = error.message || 'Something failed!';
					}
					this.atBats = 0;
					this.walks = 0;
					this.hbp = 0;
					this.sf = 0;
					this.so = 0;
					this.singles = 0;
					this.doubles = 0;
					this.triples = 0;
					this.homeruns = 0;
					this.ip = 0;
					this.hits = 0;
					this.runs = 0;
					this.er = 0;
					this.bb = 0;
					this.k = 0;
					this.hr = 0;
					this.loadUserStats();
					this.close();
					// if user just has batting stats and is not a pitcher
				} else {
					const payload = {
						atBats: this.atBats + this.getStats.atBats,
						walks: this.walks + this.getStats.walks,
						hbp: this.hbp + this.getStats.hbp,
						sf: this.sf + this.getStats.sf,
						so: this.so + this.getStats.so,
						singles: this.singles + this.getStats.singles,
						doubles: this.doubles + this.getStats.doubles,
						triples: this.triples + this.getStats.triples,
						homeruns: this.homeruns + this.getStats.homeruns,
						user: this.selectedPlayer.user,
					};
					console.log(3);
					try {
						await this.$store.dispatch('stats/addNewStats', payload);
					} catch (error) {
						this.error = error.message || 'Something failed!';
					}
					this.atBats = 0;
					this.walks = 0;
					this.hbp = 0;
					this.sf = 0;
					this.so = 0;
					this.singles = 0;
					this.doubles = 0;
					this.triples = 0;
					this.homeruns = 0;
					this.ip = 0;
					this.hits = 0;
					this.runs = 0;
					this.er = 0;
					this.bb = 0;
					this.k = 0;
					this.hr = 0;
					this.loadUserStats();
					this.close();
				}
			} else {
				// if user is a pitcher and has no batting stats or pitching stats
				var pitcher = false;
				for (const pos of this.selectedPlayer.user.positions) {
					if (pos === 'P') {
						pitcher = true;
					}
				}
				if (pitcher === true) {
					const payload = {
						atBats: this.atBats,
						walks: this.walks,
						hbp: this.hbp,
						sf: this.sf,
						so: this.so,
						singles: this.singles,
						doubles: this.doubles,
						triples: this.triples,
						homeruns: this.homeruns,
						ip: this.ip,
						hits: this.hits,
						runs: this.runs,
						er: this.er,
						bb: this.bb,
						k: this.k,
						hr: this.hr,
						user: this.selectedPlayer.user,
					};
					try {
						await this.$store.dispatch('stats/addNewStats', payload);
					} catch (error) {
						this.error = error.message || 'Something failed!';
					}
					this.atBats = 0;
					this.walks = 0;
					this.hbp = 0;
					this.sf = 0;
					this.so = 0;
					this.singles = 0;
					this.doubles = 0;
					this.triples = 0;
					this.homeruns = 0;
					this.ip = 0;
					this.hits = 0;
					this.runs = 0;
					this.er = 0;
					this.bb = 0;
					this.k = 0;
					this.hr = 0;
					this.loadUserStats();
					this.close();
				} else {
					// if user is not a pitcher and has no batting stats
					const payload = {
						atBats: this.atBats,
						walks: this.walks,
						hbp: this.hbp,
						sf: this.sf,
						so: this.so,
						singles: this.singles,
						doubles: this.doubles,
						triples: this.triples,
						homeruns: this.homeruns,
						user: this.selectedPlayer.user,
					};
					console.log(5);
					try {
						await this.$store.dispatch('stats/addNewStats', payload);
					} catch (error) {
						this.error = error.message || 'Something failed!';
					}
					this.atBats = 0;
					this.walks = 0;
					this.hbp = 0;
					this.sf = 0;
					this.so = 0;
					this.singles = 0;
					this.doubles = 0;
					this.triples = 0;
					this.homeruns = 0;
					this.close();
				}
			}
			this.compKey += 1
			this.loadUsers();
			console.log(this.compKey)
		},
		scheduleDetails(id, team) {
			this.showSchedule = true;
			this.schedule = this.getAllSchedules.filter((i) => i.id === id);
		},
		getTeamPlayersCount(team) {
			const users = this.getUsers;
			const filterUsers = users.filter((i) => i.team === team);
			return filterUsers.length;
		},
		getSelectedScheduleLineUp() {
			const allLineUps = this.getLineUp;
			return allLineUps.filter((i) => i.season.season === this.selectedViewSchedule.season);
		},
		selectedGameLineUp() {
			const allLineUps = this.getLineUp;
			const select = allLineUps.filter(
				(i) =>
					i.game.home === this.selectedViewGame.home &&
					i.game.away === this.selectedViewGame.away &&
					i.game.week === this.selectedViewGame.week
			);
			return select;
		},
		async loadSchedules() {
			const payload = {
				divisionId: this.userDivisionId,
			};
			try {
				this.isLoading = true;
				await this.$store.dispatch('leagues/fetchSchedules', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadDivisions() {
			try {
				await this.$store.dispatch('leagues/fetchDivisions');
			} catch (error) {
				this.error = error.message;
			}
		},
		async loadUsers() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('fetchUsers');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadUserStats() {
			const payload = {
				userId: this.selectedPlayer.user.id,
			};
			try {
				await this.$store.dispatch('stats/fetchUserStats', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
		},
		async loadTeams() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('teams/fetchTeams');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadLineUps() {
			const payload = {
				teamId: this.getTeamId,
			};
			try {
				await this.$store.dispatch('teams/fetchLineUp', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
		},
		close() {
			this.showSchedule = false;
			this.showStatsForm = false;
			this.showSetLineUp = false;
			this.showEditLineUp = false;
			this.atBats = 0;
			this.walks = 0;
			this.hbp = 0;
			this.sf = 0;
			this.singles = 0;
			this.doubles = 0;
			this.triples = 0;
			this.homeruns = 0;
		},
	},
};
</script>

<style scoped>
.flip-list-move {
	transition: transform 0.5s;
}
.no-move {
	transition: transform 0s;
}
.ghost {
	opacity: 0.5;
	background: #0c0c0c;
}
</style>
